import { N as push, a9 as fallback, R as slot, X as bind_props, P as pop, Z as copy_payload, _ as assign_payload, a1 as attr, a2 as stringify, Y as spread_props, $ as ensure_array_like, a0 as store_get, T as escape_html, a3 as unsubscribe_stores, aa as sanitize_props } from "./index.js";
import { B as Button } from "./Button.js";
import { M as Menu, L as List, I as Item } from "./Menu.js";
import { p as page } from "./stores.js";
import { g as goto } from "./client.js";
import { a as analytics } from "./analytics.js";
function Portal($$payload, $$props) {
  push();
  let target = fallback($$props["target"], "body");
  $$payload.out += `<div hidden><!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----></div>`;
  bind_props($$props, { target });
  pop();
}
function PurchaseButton($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  var $$store_subs;
  let buttonRef;
  let isOpen = false;
  let size = fallback($$props["size"], 0);
  let width = fallback($$props["width"], 0);
  let containerClass = fallback($$props["containerClass"], "");
  let menuClass = fallback($$props["menuClass"], "");
  let context = fallback($$props["context"], "default");
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    $$payload2.out += `<div${attr("class", `flex flex-col ${stringify(containerClass)}`)}>`;
    Button($$payload2, spread_props([
      {
        size,
        startIcon: "mdi:shopping",
        endIcon: isOpen ? "mdi:chevron-up" : "mdi:chevron-down",
        label: "Buy Glimmr Pro",
        secondaryLabel: "Lifetime license: Choose your price"
      },
      $$sanitized_props,
      {
        get ref() {
          return buttonRef;
        },
        set ref($$value) {
          buttonRef = $$value;
          $$settled = false;
        },
        get offsetWidth() {
          return width;
        },
        set offsetWidth($$value) {
          width = $$value;
          $$settled = false;
        }
      }
    ]));
    $$payload2.out += `<!----> `;
    Portal($$payload2, {
      children: ($$payload3) => {
        Menu($$payload3, {
          anchor: false,
          anchorElement: buttonRef,
          anchorCorner: "BOTTOM_LEFT",
          class: `my-2 z-50 rounded-2xl ${stringify(menuClass)}`,
          style: `min-width: ${stringify(width)}px;`,
          get open() {
            return isOpen;
          },
          set open($$value) {
            isOpen = $$value;
            $$settled = false;
          },
          children: ($$payload4) => {
            List($$payload4, {
              children: ($$payload5) => {
                const each_array = ensure_array_like(store_get($$store_subs ??= {}, "$page", page).data.prices);
                $$payload5.out += `<!--[-->`;
                for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
                  let price = each_array[$$index];
                  const handlePriceClick = () => {
                    analytics.track("start_checkout", { price });
                    goto();
                  };
                  Item($$payload5, {
                    onSMUIAction: handlePriceClick,
                    class: "font-medium",
                    children: ($$payload6) => {
                      $$payload6.out += `<!---->$${escape_html(price)}`;
                    },
                    $$slots: { default: true }
                  });
                }
                $$payload5.out += `<!--]-->`;
              },
              $$slots: { default: true }
            });
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, {
    size,
    width,
    containerClass,
    menuClass,
    context
  });
  pop();
}
export {
  PurchaseButton as P
};
